import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import AnalyticChartData from "../../../../api/AnalyticChartData";
import stateAnalyticApp from "../../../../state/stateAnalyticApp";

export const CalculationPercent = observer(() => {
  const percentValues = useMemo(() => {
    const slices = AnalyticChartData.DataSet.SERIALISATION.datasetsCount.slices;
    const getCount = (name) => {
      const slice = slices.find((s) => s.name === name);
      return slice ? slice.value : 0;
    };
    const verifiCountCalc = getCount("Верификация");
    const defectCountCalc = getCount("Брак");
    const incidentCountCalc = getCount("Инцидент");
    const allCount = verifiCountCalc + defectCountCalc + incidentCountCalc;
    const toPercent = (value) =>
      allCount > 0 ? Math.round((value * 1000) / allCount) / 10 : null;

    return {
      verifi: toPercent(verifiCountCalc),
      defect: toPercent(defectCountCalc),
      incident: toPercent(incidentCountCalc),
    };
  }, [stateAnalyticApp.loaded_verify_count]);

  return (
    <ul className="calculation_percent_container">
      <li className="calculation_percent_row">
        <span className="calculation_percent_name">Верифицированно:</span>{" "}
        {percentValues.verifi !== null
          ? `${percentValues.verifi}%`
          : "Нет данных"}
      </li>
      <li className="calculation_percent_row">
        <span className="calculation_percent_name">Брак:</span>{" "}
        {percentValues.defect !== null ? (
          <span
            style={{
              color:
                percentValues.defect >= 2 && percentValues.defect < 3
                  ? "var(--mast-yellow)"
                  : percentValues.defect >= 3
                    ? "var(--error)"
                    : "black",
            }}
          >
            {percentValues.defect}%
          </span>
        ) : (
          "Нет данных"
        )}
      </li>
      <li className="calculation_percent_row">
        <span className="calculation_percent_name">Инцидентов:</span>{" "}
        {percentValues.incident !== null
          ? `${percentValues.incident}%`
          : "Нет данных"}
      </li>
    </ul>
  );
});
